<pbc-filter [config]="ZeitArtsFilterConfig" [filter]="zeitArts.filter$ | async" (filterChange)="zeitArts.filter$.next($event)"></pbc-filter>
